var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgRecherche = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19.777,
    viewBox: "0 0 17 19.777",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dispo",
    transform: "translate(-596 -92.223)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_42",
    "data-name": "Groupe 42",
    transform: "translate(394 14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_622669",
    "data-name": 622669,
    transform: "translate(202 80.997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_7",
    "data-name": "Groupe 7",
    transform: "translate(0 0.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3",
    "data-name": "Trac\\xE9 3",
    d: "M16.793,15.794,11.958,10.96a6.742,6.742,0,1,0-1,1L15.791,16.8a.708.708,0,1,0,1-1ZM6.729,12.045a5.313,5.313,0,1,1,5.313-5.313A5.318,5.318,0,0,1,6.729,12.045Z",
    transform: "translate(0 -0.003)",
    fill: "#5471a9"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20",
    "data-name": "Trac\\xE9 20",
    d: "M288.077,86.125l1.882,3.021,6.763-8.106",
    transform: "translate(-81)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_21",
    "data-name": "Trac\\xE9 21",
    d: "M288.077,86.125l1.882,3.021,6.763-8.106",
    transform: "translate(-81)",
    fill: "none",
    stroke: "#5471a9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRecherche, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/recherche.a196f154.svg";
export { ForwardRef as ReactComponent };